module.exports = "/images/blue-arrow.svg?488aeaa2fb67f109a9d62152683ef532";